import type { RouteRecordRaw } from 'vue-router'
import { createRouter, createWebHistory } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('./app-page.vue'),
  },

  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('./app-page.vue'),
  },
]

export const router = createRouter({
  routes,
  history: createWebHistory(),
})

// router.beforeEach(async (to, from, next) => {
//   log.info(`before route to=${to?.fullPath} from=${from?.fullPath}`)
//   next()
// })
